import { render, staticRenderFns } from "./Stocktaking.vue?vue&type=template&id=bf025322&"
import script from "./Stocktaking.vue?vue&type=script&lang=js&"
export * from "./Stocktaking.vue?vue&type=script&lang=js&"
import style0 from "./Stocktaking.vue?vue&type=style&index=0&id=bf025322&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports